import styled, { css } from 'styled-components';
import { Folder } from '@mui/icons-material';

export const FolderIcon = styled(Folder)(
	({ theme }) => css`
		color: ${theme.palette.primary.main};
		vertical-align: middle;
	`,
);
